import { ThemeProvider, createTheme } from "@mui/material/styles";
import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import PsContextProvider from "./context/PsContextProvider";

import UserLoginPage from "./pages/auth/UserLoginPage";
import { CssBaseline } from "@mui/material";
import AppLayout from "./pages/layout/AppLayout";
import { DialogProvider } from "./context/DialogContext";
import Settings from "./pages/settings";

const themeVariantColor = [
  { primary: "#1976d2" },
  { error: "#d32f2f" },
  { warning: "#ed6c02" },
  { success: "#2e7d32" },
  { purple: "#9c27b0" },
  { pink: "#ff3f81" },
  { white: "#ffffff" },
];

const colorObjValue = themeVariantColor.find((colorObj) => colorObj["primary"]);

const customTheme = createTheme({
  palette: {
    primary: {
      main: colorObjValue["primary"], // Primary color (green)
    },
  },
  typography: {
    fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
  },
  components: {
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: "50px", // Set the global minHeight for Toolbar
          "@media (min-width:600px)": {
            minHeight: "50px", // Optional: Adjust for larger screens if needed
          },
        },
      },
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={customTheme}>
      <CssBaseline />
      <PsContextProvider>
        <DialogProvider>
          <HashRouter>
            <Routes>
              <Route path="/app/*" element={<AppLayout />} />
              <Route path="/" element={<UserLoginPage />} exact />
            </Routes>
          </HashRouter>
        </DialogProvider>
      </PsContextProvider>
    </ThemeProvider>
  );
};

export default App;
